import { ToolTip, Icon } from "@moneyforward/mfx_biz_react_components";

export const AuthorityToolTip = () => {
  return (
    <ToolTip
      variant="guide"
      text={`役職者等業務上システムの管理者となりうる方については、Mikatano IDの権限を管理者に設定していただくことをおすすめします。`}
    >
      <Icon
        name="help"
        size="sm"
        bgSize="sm"
        hasAction
        css={{ margin: "0 8px 0 8px" }}
      />
    </ToolTip>
  );
};
